import AxiosInstance from "./api";

export const AccountingTable10Service = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/accounting-table-10s/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/accounting-table-10s/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/accounting-table-10s", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/accounting-table-10s/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/accounting-table-10s/" + id);
  },
};
